import { IGetState } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { updateBoardName } from '../../../../../../../../../rest/effects/board/updateBoardName';
import { boardSetDescription } from '../../../../../../../../../rest/effects/board/boardSetDescription';
import { boardSetStatus } from '../../../../../../../../../rest/effects/board/boardSetStatus';
import { TStatus } from '../../../../../../../../../types/model';
import {
    snackbarBoardArchived,
    snackbarBoardUnarchived,
    snackbarCardUnarchived
} from '../../../../../../../snackbarsStack';
import {
    ERestActivityModelType,
    ERestActivityPropertyActionType,
    ERestActivityPropertyName
} from '../../../../../../../../../types/rest/activity/IRestActivityBase';
import { getBoard } from '../../../../../../../../../store/model/selectors/getBoardById';
import {
    saveListName
} from '../../../../../../listDetails/nameDescriptionSection/hocs/NameDescriptionInputHOC/effects/saveListName';
import {
    saveListDescription
} from '../../../../../../listDetails/nameDescriptionSection/hocs/NameDescriptionInputHOC/effects/saveListDescription';
import { unarchiveAllCards } from '../../../../../../../base/effects/unarchiveAllCards';
import { archiveList } from '../../../../../../../base/effects/archiveList';
import { listSetMaxCardNumber } from '../../../../../../../../../rest/effects/list/listSetMaxCardNumber';
import {
    toggleCardsNumber
} from '../../../../../../listDetails/cardsLimitSection/hocs/LimitCardsNumberTogglerHOC/effects/toggleCardsNumber';
import { cardSetName } from '../../../../../../../../../rest/effects/card/card/cardSetName';
import {
    saveDescription
} from '../../../../../../cardDetails/DescriptionSection/hocs/CardDescriptionHOC/effects/saveDescription';
import { isBoardCardsLimitReached } from '../../../../../../../../../store/model/selectors/isBoardCardsLimitReached';
import {
    showBoardLimitSnackbarAndEvent
} from '../../../../../../../../../store/model/effects/showBoardLimitSnackbarAndEvent';
import { SegmentUserTypeOption } from '../../../../../../../../../middlewares/segment/trackEntities/userEvents';
import { cardsUnarchive } from '../../../../../../../../../rest/effects/card/card/cardsUnarchive';
import { cardsArchiveOrDelete } from '../../../../../../../base/effects/cardsArchiveOrDelete';
import {
    deselectUser
} from '../../../../../../cardDetails/AssigneesSection/hocs/AssigneesSearchSelectHOC/effects/deselectUser';
import {
    selectUser
} from '../../../../../../cardDetails/AssigneesSection/hocs/AssigneesSearchSelectHOC/effects/selectUser';
import {
    IRestCardAssignUserActivity
} from '../../../../../../../../../types/rest/activity/IRestCardAssignUserActivity';
import { IRestBoardCommonActivity } from '../../../../../../../../../types/rest/activity/IRestBoardCommonActivity';
import { IRestCardCommonActivity } from '../../../../../../../../../types/rest/activity/IRestCardCommonActivity';
import { IRestListCommonActivity } from '../../../../../../../../../types/rest/activity/IRestListCommonActivity';
import { cardSetStartDateWithEpics } from '../../../../../../../../../rest/effects/card/card/cardSetStartDateWithEpics';
import { cardSetDueDateWithEpics } from '../../../../../../../../../rest/effects/card/card/cardSetDueDateWithEpics';
import { cardSetEstimate } from '../../../../../../../../../rest/effects/card/card/cardSetEstimate';
import { IRestCardListActivity } from '../../../../../../../../../types/rest/activity/IRestCardListActivity';
import { cardMoveToList } from '../../../../../../../../../rest/effects/card/card/move/cardMoveToList';
import { getListViewCard } from '../../../../../../../listView/selectors/getListViewCard';
import { listUpdateMinMaxOrderNumber } from '../../../../../../../../../rest/effects/list/listUpdateMinMaxOrderNumber';
import { getList } from '../../../../../../../../../store/model/list/selectors/getList';
import {
    cardMoveToAnotherBoard
} from '../../../../../../cardDetails/MoveToSection/hocs/CardMoveToHOC/effects/cardMoveToAnotherBoard';
import { cardSetPriority } from '../../../../../../../../../rest/effects/card/card/cardSetPriority';
import { NO_PRIORITY } from '../../../../../../../helpers/constants';
import { cardSetTags } from '../../../../../../../../../rest/effects/card/card/cardSetTags';
import { IRestCardTagActivity } from '../../../../../../../../../types/rest/activity/IRestCardTagActivity';
import { getCardTags } from '../../../../../../../../../store/model/selectors/getCardTags';
import { IRestCardColorActivity } from '../../../../../../../../../types/rest/activity/IRestCardColorActivity';
import { getCardColorTags } from '../../../../../../../../../store/model/selectors/getCardColorTags';
import { cardSaveColorTags } from '../../../../../../../../../rest/effects/card/card/cardSaveColorTags';
import {
    IRestCardCustomPropertyActivity
} from '../../../../../../../../../types/rest/activity/IRestCardCustomPropertyActivity';
import {
    saveProperties
} from '../../../../../../cardDetails/CustomPropertiesSection/hocs/CustomPropertiesSectionHOC/effects/saveProperties';
import { segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    SegmentActivityEvent,
    SegmentActivityOptions,
    SegmentActivityTypeValue
} from '../../../../../../../../../middlewares/segment/trackEntities/activityEvents';
import {
    ICustomPropertiesElement
} from '../../../../../../../base/components/CustomProperties/components/CustomProperty/types';
import {
    getBoardCustomProperties
} from '../../../../../details/CardCustomProperties/hocs/CustomPropertiesHOC/selectors/getBoardCustomProperties';
import {
    updateValue
} from '../../../../../../../base/components/CustomProperties/hocs/CustomPropertyHOC/effects/updateValue';

export const onUndo = (
    activity: IRestBoardCommonActivity | IRestCardCommonActivity | IRestListCommonActivity,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const {
            modelType,
            oldValue,
            dashboardId: boardId,
            propertyName,
            modelId,
            propertyActionType,
        } = activity;
        let segmentValue;
        if (modelType === ERestActivityModelType.BOARD) {
            if (propertyName === ERestActivityPropertyName.NAME) {
                segmentValue = SegmentActivityTypeValue.BOARD_NAME;
                dispatch(updateBoardName(boardId, oldValue));
            } else if (propertyName === ERestActivityPropertyName.DESCRIPTION) {
                segmentValue = SegmentActivityTypeValue.BOARD_DESC;
                dispatch(boardSetDescription(boardId, oldValue || ''));
            } else if (propertyName === ERestActivityPropertyName.STATUS) {
                segmentValue = SegmentActivityTypeValue.BOARD_STATUS;
                const { status } = getBoard(state, boardId);
                const newStatus = status === TStatus.STATUS_ACTIVE ? TStatus.STATUS_ARCHIVE : TStatus.STATUS_ACTIVE;
                dispatch(boardSetStatus(boardId, newStatus)).then(() => {
                    if (newStatus === TStatus.STATUS_ACTIVE) {
                        dispatch(snackbarBoardArchived());
                    } else {
                        dispatch(snackbarBoardUnarchived());
                    }
                });
            }
        } else if (modelType === ERestActivityModelType.LIST) {
            const listId = modelId;
            if (propertyName === ERestActivityPropertyName.NAME) {
                segmentValue = SegmentActivityTypeValue.LIST_NAME;
                dispatch(saveListName(listId, oldValue));
            } else if (propertyName === ERestActivityPropertyName.DESCRIPTION) {
                segmentValue = SegmentActivityTypeValue.LIST_DESC;
                dispatch(saveListDescription(listId, oldValue || ''));
            } else if (propertyName === ERestActivityPropertyName.STATUS) {
                segmentValue = SegmentActivityTypeValue.LIST_STATUS;
                const { status } = getBoard(state, boardId);
                if (status === TStatus.STATUS_ACTIVE) {
                    dispatch(unarchiveAllCards(listId, boardId));
                } else {
                    dispatch(archiveList(listId, boardId));
                }
            } else if (propertyName === ERestActivityPropertyName.MAX_CARD_NUMBER) {
                segmentValue = SegmentActivityTypeValue.LIST_CARD_NUMBER;
                if (!oldValue) {
                    dispatch(toggleCardsNumber(listId));
                } else {
                    dispatch(listSetMaxCardNumber(listId, Number(oldValue)));
                }
            }
        } else if (modelType === ERestActivityModelType.CARD) {
            const cardId = modelId;
            if (propertyName === ERestActivityPropertyName.NAME) {
                segmentValue = SegmentActivityTypeValue.CARD_NAME;
                dispatch(cardSetName(cardId, oldValue));
            } else if (propertyName === ERestActivityPropertyName.DESCRIPTION) {
                segmentValue = SegmentActivityTypeValue.CARD_DESC;
                dispatch(saveDescription(cardId, oldValue || ''));
            } else if (propertyName === ERestActivityPropertyName.STATUS) {
                segmentValue = SegmentActivityTypeValue.CARD_STATUS;
                const { status } = getBoard(state, boardId);
                if (status === TStatus.STATUS_ACTIVE) {
                    dispatch(cardsArchiveOrDelete([cardId]));
                } else {
                    if (isBoardCardsLimitReached(getState(), boardId , 1)){
                        dispatch(showBoardLimitSnackbarAndEvent(SegmentUserTypeOption.CARD_CREATION));
                    } else {
                        dispatch(cardsUnarchive([cardId])).then(() => dispatch(snackbarCardUnarchived()));
                    }
                }
            } else if (propertyName === ERestActivityPropertyName.ASSIGNEES) {
                segmentValue = SegmentActivityTypeValue.CARD_ASSIGNEES;
                const { users } = activity as IRestCardAssignUserActivity;
                users.map(user => {
                    if (propertyActionType === ERestActivityPropertyActionType.ADD) {
                        dispatch(deselectUser(boardId, user.permissionId));
                    } else {
                        dispatch(selectUser(boardId, user.permissionId));
                    }
                });
            } else if (propertyName === ERestActivityPropertyName.START_DATE) {
                segmentValue = SegmentActivityTypeValue.CARD_START_DATE;
                dispatch(cardSetStartDateWithEpics(cardId, oldValue ? parseInt(oldValue) : null));
            } else if (propertyName === ERestActivityPropertyName.DUE_DATE) {
                segmentValue = SegmentActivityTypeValue.CARD_DUE_DATE;
                dispatch(cardSetDueDateWithEpics(cardId, oldValue ? parseInt(oldValue) : null));
            } else if (propertyName === ERestActivityPropertyName.ESTIMATE) {
                segmentValue = SegmentActivityTypeValue.CARD_ESTIMATE;
                dispatch(cardSetEstimate(cardId, oldValue ? parseInt(oldValue) : null));
            } else if (propertyName === ERestActivityPropertyName.LIST) {
                segmentValue = SegmentActivityTypeValue.CARD_LIST;
                const { oldList, oldBoard, newBoard, newList } = activity as IRestCardListActivity;
                const listId = oldList.id;
                if (oldBoard.id !== newBoard.id) {
                    const boardId = oldBoard.id;
                    const board = getBoard(state, boardId);
                    if (board && board.id) { // доски может не быть
                        dispatch(cardMoveToAnotherBoard(cardId, board, listId));
                    }
                } else {
                    const list = getList(state, listId);
                    if (list) { // листа может не быть
                        dispatch(cardMoveToList(cardId, listId))
                            .then(() => {
                                const { orderNumber } = getListViewCard(getState(), cardId);
                                dispatch(listUpdateMinMaxOrderNumber(listId, [orderNumber]));
                            });
                    }
                }
            } else if (propertyName === ERestActivityPropertyName.PRIORITY) {
                segmentValue = SegmentActivityTypeValue.CARD_PRIORITY;
                dispatch(cardSetPriority(cardId, oldValue || NO_PRIORITY));
            } else if (propertyName === ERestActivityPropertyName.TAGS) {
                segmentValue = SegmentActivityTypeValue.CARD_TAGS;
                const { tags } = activity as IRestCardTagActivity;
                let prevTags = getCardTags(state, cardId);
                if (propertyActionType === ERestActivityPropertyActionType.ADD) {
                    prevTags = prevTags.reduce((prevTags, tag) => {
                        if (!tags.includes(tag)) {
                            prevTags.push(tag);
                        }
                        return prevTags;
                    }, []);
                } else if (propertyActionType === ERestActivityPropertyActionType.DELETE) {
                    prevTags = [...prevTags, ...tags];
                }
                dispatch(cardSetTags(cardId, prevTags));
            } else if (propertyName === ERestActivityPropertyName.COLOR_ID) {
                segmentValue = SegmentActivityTypeValue.CARD_COLOR_TAGS;
                let { oldColors } = activity as IRestCardColorActivity;
                // удаляем новые колортеги (т.к. нет айдишника последний с таким же именем и цветом)
                const colorTags = getCardColorTags(state, cardId).reduce((colorTags, colorTag) => {
                    const oldColorIndex = oldColors.findIndex(oldColor => oldColor.color === colorTag.color && oldColor.name === colorTag.name);
                    if (oldColorIndex === -1) {
                        oldColors = [
                            ...oldColors.slice(0, oldColorIndex),
                            ...oldColors.slice(oldColorIndex + 1),
                        ];
                        return colorTags;
                    }
                    return [...colorTags, colorTag];
                }, []).map(colorTag => colorTag.id);
                dispatch(cardSaveColorTags(cardId, colorTags));
                //@ts-ignore
            } else if (activity.customProperty) {
                segmentValue = SegmentActivityTypeValue.CARD_CUSTOM;
                const { customProperty } = activity as IRestCardCustomPropertyActivity;
                let elements: ICustomPropertiesElement[];
                const customProperties = getBoardCustomProperties(state, boardId);
                if (propertyActionType === ERestActivityPropertyActionType.ADD) {
                    elements = customProperties.filter(item => item.id !== customProperty.id);
                } else if (propertyActionType === ERestActivityPropertyActionType.DELETE) {
                    elements = [...elements, customProperty];
                } else {
                    dispatch(updateValue(cardId, customProperty.id, oldValue));
                }
                if (elements) {
                    dispatch(saveProperties(boardId, elements)).then(() => {
                        dispatch(updateValue(cardId, customProperty.id, oldValue));
                    });
                }
            }
        }

        dispatch(segmentTrackAction(SegmentActivityEvent.UNDO_CLICKED, {
            name: SegmentActivityOptions.TYPE,
            value: segmentValue,
        }));
    };
    return action;
};
